<div class="wrapper wrapper-content mtv-parcels-page row">
    <div class="ibox mainPartPage">
        <div class="ibox-content"
             [ngStyle]="{width: dailyReportsService.showDetailedView ? 'calc(100% - 420px)' : ''}">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Daily Reports'" [buildings]="dailyReportsService.buildingsForRead"></filter>
                </div>

                <daily-reports-filter></daily-reports-filter>

                <div *ngIf="dailyReportsService.canEdit()" class="col-sm-3">
                    <button type="button"
                            class="btn btn-w-m btn-primary pull-right"
                            (click)="dailyReportsService.isDailyReportsModalShow = true">
                        <i class="fa fa-plus-circle"></i> New Report
                    </button>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12">
                    <filters-view></filters-view>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allDailyReports'" [ngClass]="{'sk-loading': dailyReportsService.spinnerShow}">
                    <daily-reports-list></daily-reports-list>
                </tab-item>
                <pagination *ngIf="dailyReportsService.data.allDailyReports.total && urlService.queryParams['page']"
                            [total]="dailyReportsService.data['allDailyReports'].total">
                </pagination>
                <spinner [spinnerShow]="dailyReportsService.spinnerShow"></spinner>
            </tabs-wrapper>
        </div>
        <div class="animated animated-directory slideInRight detailed-view dv-sidebar">
            <daily-reports-detailed-view *ngIf="dailyReportsService.showDetailedView"></daily-reports-detailed-view>
        </div>
    </div>
</div>

<daily-reports-modal *ngIf="dailyReportsService.isDailyReportsModalShow"></daily-reports-modal>
<daily-reports-add-entry-modal *ngIf="dailyReportsService.addEntryModal"></daily-reports-add-entry-modal>
<daily-reports-view-report-modal *ngIf="dailyReportsService.showDailyEntriesModal"></daily-reports-view-report-modal>



// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports.component.html